import { getUsersByUserId, patchBlockUser, User } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseUserActionsProps {
  userId: string;
}
export const useUserActions = ({ userId }: UseUserActionsProps) => {
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const { request, loading } = useRequest();

  const patchBlockUsersAndGetUsersByUserId = async ({ users }: { users: User[] }) => {
    for await (const user of users) {
      await request(patchBlockUser, { userId: user.id });
    }
    await revalidate();
  };

  return { patchBlockUsersAndGetUsersByUserId, loading };
};
